import { requireEnv } from '../../util/env';

export const STORAGE_KEYS = {
	AUTH_TOKENS: 'cheqroom_auth_tokens',
	LAST_ACTIVE_WORKSPACE: 'cheqroom_last_active_workspace',
	ACCESS_TOKEN: 'accessToken',
	SESSION_TOKEN: 'sessionToken',
} as const;

export const MIN_REFRESH_TIME_IN_MINUTES = 5;

export const AUTH_URL = requireEnv(process.env.LOGIN_URL, 'LOGIN_URL');
export const AUTH_TOKEN_URL = requireEnv(process.env.AUTH_TOKEN_URL, 'AUTH_TOKEN_URL');
export const DEFAULT_API_URL = requireEnv(process.env.API_URL, 'API_URL');

export const BASE_URL_PATHS = [
	'calendar',
	'items',
	'kits',
	'contacts',
	'users',
	'reservations',
	'check-outs',
	'spotchecks',
	'reports',
	'admin',
	'profile',
	'welcome',
	'not-found',
] as const;

/** First path segments treated as routes, not workspace IDs. Used by getWorkspaceIdFromPath. */
export const RESERVED_PATH_SEGMENTS: readonly string[] = [...BASE_URL_PATHS, 'login', 'forgot-password'];
